import { ref, get, query, orderByChild } from "firebase/database";
import { PaymentData } from "../../models/payment";
import { db } from "../firebaseConfig";

export const getPayments = async (): Promise<PaymentData[]> => {
	const paymentsRef = ref(db, "payments");
	const paymentsQuery = query(paymentsRef, orderByChild("invoiceNumber"));
	const snapshot = await get(paymentsQuery);
	const payments: PaymentData[] = [];

	if (snapshot.exists()) {
		snapshot.forEach((child) => {
			const val = child.val();
			payments.push(val as PaymentData);
		});
	}

	return payments;
};
